<div class="display-container" [ngClass]="setTheme(darkThemeService.isDarkTheme.getValue())">
  <!-- START AUTHENTICATING -->
  <div *ngIf="isLoading" class="loading-screen-container">
    <app-loading-screen></app-loading-screen>
  </div>
  <!-- END AUTHENTICATING -->

  <!-- START NOT AUTHENTICATED -->
  <div *ngIf="isUnAuthenticated" class="login-screen-container">
    <app-login-screen></app-login-screen>
  </div>
  <!-- END NOT AUTHENTICATED -->

  <!-- START AUTHENTICATED -->
  <div *ngIf="isAuthenticated" class="authenticated-screen-container">
    <app-navbar *ngIf="!isFullscreenRoute"></app-navbar>
    <app-side-nav *ngIf="!isFullscreenRoute" class="side-nav"></app-side-nav>
    <router-outlet *ngIf="isFullscreenRoute"></router-outlet>
  </div>
  <!-- END AUTHENTICATED -->
</div>